import axios from 'axios'

export function getVideogames(){
    return async function(dispatch){
        const json = await axios('/videogames')
        dispatch({
            type: 'GET_VIDEOGAMES',
            payload: json.data
        })
    }
}

export function getGenres() {
    return async function(dispatch){
        const json = await axios('/genres')
        dispatch({
            type: 'GET_GENRES',
            payload: json.data
        })
    }
}

export function filterVideogamesByGenre(payload){
    return {
        type: 'FILTER_BY_GENRE',
        payload
    }
}

export function filterCreated(payload){
    return {
        type: 'FILTER_CREATED',
        payload
    }
}

export function orderBy(payload){
    return {
        type: 'ORDER_BY',
        payload
    }
}

export function orderByRating(payload){
    return {
        type: 'ORDER_BY_RATING',
        payload
    }
}

export function searchByName(payload){
    return async function(dispatch){
        try {
            const json = await axios(`/videogames?name=${payload}`)
            dispatch({
                type: 'SEARCH_BY_NAME',
                payload: json.data
            })
        } catch(error) {
            dispatch({
                type: 'SEARCH_BY_NAME',
                payload: []
            })
        }
    }
}

export function postVideogame(payload){
    return async function(){
        const json = await axios.post('/videogames', payload) 
        return json
    }
}

export function updateVideogame(id, data){
    return async function(){
        const json = await axios.put(`/videogames/${id}`, data) 
        return json
    }
}

export function getDetail(payload){
    return async function(dispatch){
        const json = await axios(`/videogames/${payload}`)
        dispatch({
            type: 'GET_DETAIL',
            payload: json.data
        })
    }
}
export function deleteVideogame(payload){
    return async function(dispatch){
        const json = await axios.delete(`/videogames/${payload}`)
        return json
    }
}